import { useEffect, useState } from 'react'
import Cache from '@fs/zion-cache'

import { CACHE } from '../../helpers'

const customBackgroundImageCache = new Cache({ storeName: CACHE.STORE_NAME })

export default function useCachedBackgroundImage() {
  const [cachedBackgroundImage, setCachedBackgroundImage] = useState()

  useEffect(() => {
    let isMounted = true

    customBackgroundImageCache.getItem(CACHE.BACKGROUND_IMAGE_KEY).then((cachedImage) => {
      if (isMounted) {
        setCachedBackgroundImage(cachedImage)
      }
    })

    return () => {
      isMounted = false
    }
  }, [])

  useEffect(() => {
    if (cachedBackgroundImage !== undefined) {
      customBackgroundImageCache.setItem(CACHE.BACKGROUND_IMAGE_KEY, cachedBackgroundImage)
    }
  }, [cachedBackgroundImage])

  return [cachedBackgroundImage, setCachedBackgroundImage]
}
